export default[
  {
    path: "/",
    name: "login",
    component: () => import("@/views/studentSide/project/login")
  },
  {
    path: "/user",
    name: "user",
    component: () => import("@/views/studentSide/userCenter/layout"),
    redirect: "/user/project",
    children:[
      // 我的项目
      {
        path: "project",
        name: "userProject",
        component: () => import("@/views/studentSide/userCenter/project"),
      },
      // 个人信息
      {
        path: "message",
        name: "userMessage",
        component: () => import("@/views/studentSide/userCenter/message"),
      }
    ]
  },
  // 一级页面
  {
    path: "/project",
    name: "project",
    component: () => import("@/views/studentSide/project/layout"),
    redirect: "/project/mustCourse",
    children:[
      // 必修课程
      {
        path: "mustCourse",
        name: "projectMustCourse",
        component: () => import("@/views/studentSide/project/mustCourse"),
      },
      // 选修课程
      {
        path: "selectCourse",
        name: "projectSelectCourse",
        component: () => import("@/views/studentSide/project/selectCourse"),
      },
      // 公开课程
      {
        path: "/project/publicResourceCourse",
        name: "publicResourceCourse",
        component: () => import("@/views/studentSide/project/publicResourceCourse"),
      },
      // 我的笔记
      {
        path: "task",
        name: "projectTask",
        component: () => import("@/views/studentSide/project/task"),
      },
      // 我的作业 培训成果  培训总结
      {
        path: "work",
        name: "projectWork",
        component: () => import("@/views/studentSide/project/work"),
      },
      // 培训成果
      {
        path: "achievement",
        name: "projectAchievement",
        component: () => import("@/views/studentSide/project/achievement"),
      },
      // 培训总结
      {
        path: "train",
        name: "projectTrain",
        component: () => import("@/views/studentSide/project/train"),
      },
      // 我的档案
      {
        path: "file",
        name: "projectFile",
        component: () => import("@/views/studentSide/project/file"),
      },
      // 主题研讨
      {
        path: "seminar",
        name: "projectSeminar",
        component: () => import("@/views/studentSide/project/seminar"),
      },
      // 辅助资料
      {
        path: "assist",
        name: "projectAssist",
        component: () => import("@/views/studentSide/project/assist"),
      },
      // 辅助工具
      {
        path: "tool",
        name: "projectTool",
        component: () => import("@/views/studentSide/project/tool"),
      },
      // 电子证书
      {
        path: "certificate",
        name: "projectCertificate",
        component: () => import("@/views/studentSide/project/certificate"),
      },
      // 问卷调查
      {
        path: "paper",
        name: "projectPaper",
        component: () => import("@/views/studentSide/project/paper"),
      }
    ]
  },
  {
    path: "/portalSite/video",
    name: "portalSiteVideo",
    component: () => import("@/views/studentSide/project/video")
  },
  // 二级页面
  {
    path: "/project",
    name: "",
    component: () => import("@/views/studentSide/project/innerLayout"),
    children:[
      {
        path: "task/content",
        name: "projectTaskContent",
        component: () => import("@/views/studentSide/project/taskContent"),
      },
      {
        path: "contentShow",
        name: "projectContentShow",
        component: () => import("@/views/studentSide/components/ContentShow"),
      },
      // 主题研讨
      {
        path: "seminarContent",
        name: "seminarContent",
        component: () => import("@/views/studentSide/components/SeminarContent"),
      },
      {
        path: "paperView",
        name: "projectPaperView",
        component: () => import("@/views/studentSide/project/paperView"),
      },
      {
        path: "paperTest",
        name: "projectPaperTest",
        component: () => import("@/views/studentSide/project/paperTest"),
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/studentSide.js